const isPaymentCheckoutVisible = (paymentSum) => {
    const total = paymentSum?.data?.sum_total;

    return total !== undefined && total !== null && total !== '';
};

const hasPenaltyAmount = (calculation) => Number(calculation?.sum_peny) > 0;

const normalizeReceiptEmail = (email) => (
    typeof email === 'string' ? email.trim() : ''
);

const isValidReceiptEmail = (email) => {
    const normalized = normalizeReceiptEmail(email);
    return normalized.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized);
};

const buildPublicPaymentPayload = ({ number, monthFrom, monthTo, year, email }) => ({
    number,
    month_from: Number(monthFrom),
    month_to: Number(monthTo || monthFrom),
    year,
    email: normalizeReceiptEmail(email),
});

const canSubmitPublicPayment = ({
    number,
    monthFrom,
    year,
    email,
    paymentSum,
    makePending = false,
}) => Boolean(
    number
    && Number(monthFrom)
    && year
    && isValidReceiptEmail(email)
    && isPaymentCheckoutVisible(paymentSum)
    && !makePending
);

module.exports = {
    isPaymentCheckoutVisible,
    hasPenaltyAmount,
    buildPublicPaymentPayload,
    normalizeReceiptEmail,
    isValidReceiptEmail,
    canSubmitPublicPayment,
};
